import '../../resources/css/dashboard/MapDetail.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { closeDeviceStatus } from '../../actions/dashboard/index';
import Loading from '../../components/common/Loading';

class MapDetail extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { closeDeviceStatus } = this.props;
    closeDeviceStatus();
  }

  renderOnline() {
    const { isOnline } = this.props;

    let iconClass;
    if (isOnline === 1) {
        iconClass = 'icon-online';
    } else {
        iconClass = 'icon-offline';
    }

    return (
        <div className="area-title-field">
          <div className='area-label'>Status</div>
            <div className='area-online-icon'>
                <span className={ iconClass } />
            </div>
        </div>
        
    );
  }

  renderInfoTitle = (label, value) => {    
    return (
      <div className='area-title-field'>
        <div className='area-label'>{ label }</div>
        <div className='area-value'>{ value }</div>
      </div>
    );
  }

  renderInfoField = (label, value) => {    
    return (
      <div className='area-field'>
        <div className='area-label'>{ label }</div>
        <div className='area-value'>{ value }</div>
      </div>
    );
  }

  render() {
    const { loading, displayDetail, deviceDetailInfo } = this.props;
    let detailForm;

    if (!displayDetail) {
      detailForm = (
        <div className='no-detail-form'></div>
      );
    } else if (loading) {
      detailForm = (
        <div className='area-detail-form'><Loading loading={loading}></Loading></div>     
      );
    } else {
      const errMsg = deviceDetailInfo['faultCode'] ? deviceDetailInfo['faultCode'].toString() : '';
      
      detailForm = (
        <div className='area-detail-form'>
          <Row>
            <Col sm={3}>
              { this.renderInfoTitle('Model Number', deviceDetailInfo['modelName']) } 
            </Col>
            <Col sm={3}>
              { this.renderInfoTitle('Serial Number', deviceDetailInfo['SN']) } 
            </Col>
            <Col sm={3}>
              { this.renderOnline() }
            </Col>
            <Col sm={2}>
              { this.renderInfoTitle('ACT', deviceDetailInfo['act']) }
            </Col>
            <Col sm={1}>
              <div className="area-close-button" onClick={this.closeModal}><span className="icon-close"></span></div>
            </Col>
          </Row>
          <Row>
            <Col sm={1}>
              { this.renderInfoField('Hood Status',deviceDetailInfo['power']) } 
            </Col>
            <Col sm={1}>
              { this.renderInfoField('Fan Status', deviceDetailInfo['fan']) } 
            </Col>
            <Col sm={1}>
              { this.renderInfoField('Light Status', deviceDetailInfo['light']) } 
            </Col>
            <Col sm={3}>
              { this.renderInfoField('Grease Filter Remaining Time', deviceDetailInfo['remainGrease']) } 
            </Col>
            <Col sm={3}>
              { this.renderInfoField('Charcoal Filter Remaining Time', deviceDetailInfo['remainCharcoal']) } 
            </Col>
            <Col sm={3}>
              { this.renderInfoField('Error Status', errMsg) } 
            </Col>
          </Row>        
        </div>     
      );
    }
    
    return (
      <div className='map-detail'>
        { detailForm }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const deviceDetail = state.dashboardReducers.deviceDetail;

  return {
    displayDetail: state.mapReducers.displayDetail,
    deviceDetail: state.dashboardReducers.deviceDetail,
    deviceDetailInfo: state.dashboardReducers.deviceDetailInfo,
    loading: state.mapReducers.detailLoading,
    isOnline: deviceDetail.isOnline,
    readOnly: true 
  }
}

export default connect(
  mapStateToProps,
  { closeDeviceStatus }
)(MapDetail)